export const goesPathsB = (
  <>
    <path
      d="M14.4657 14.9667L15.1089 14.2481L15.085 14.2242L14.4419 14.9427L14.4657 14.9667Z"
      fill="currentColor"
    />
    <path
      d="M15.0611 14.1763L15.0373 14.1523L14.0845 14.9907L14.1083 15.0146L15.0611 14.1763Z"
      fill="currentColor"
    />
    <path
      d="M15.0135 14.1284L14.9897 14.1044L14.4895 14.4637L14.5133 14.4877L15.0135 14.1284Z"
      fill="currentColor"
    />
    <path
      d="M14.9658 14.0565C14.9658 14.0565 14.9658 14.0326 14.942 14.0326L14.5847 14.2242L14.6085 14.2481L14.9658 14.0565Z"
      fill="currentColor"
    />
    <path
      d="M14.5371 14.1284L14.5609 14.1523L14.942 13.9847L14.9182 13.9607L14.5371 14.1284Z"
      fill="currentColor"
    />
    <path
      d="M14.4895 14.0086V14.0326L14.8706 13.9128V13.8889L14.4895 14.0086Z"
      fill="currentColor"
    />
    <path
      d="M14.8705 13.841C14.8705 13.817 14.8705 13.817 14.8705 13.817L14.4656 13.9128V13.9368L14.8705 13.841Z"
      fill="currentColor"
    />
    <path
      d="M14.4419 13.7931V13.817L14.8468 13.7691V13.7451L14.4419 13.7931Z"
      fill="currentColor"
    />
    <path
      d="M14.4419 13.6972H14.8468C14.8468 13.6972 14.8468 13.6972 14.8468 13.6733C14.8468 13.6493 14.8468 13.6493 14.8468 13.6493H14.4419V13.6972Z"
      fill="currentColor"
    />
    <path
      d="M14.4419 13.5775L14.8468 13.6014C14.8468 13.5775 14.8468 13.5775 14.8468 13.5775L14.4419 13.5535V13.5775Z"
      fill="currentColor"
    />
    <path
      d="M14.4656 13.4577L14.8705 13.5535V13.5296L14.4656 13.4338V13.4577Z"
      fill="currentColor"
    />
    <path
      d="M14.4895 13.3619L14.8706 13.4817V13.4577L14.4895 13.338V13.3619Z"
      fill="currentColor"
    />
    <path
      d="M14.537 13.2182L14.5132 13.2422L14.8943 13.4098C14.8943 13.4098 14.8943 13.3859 14.9181 13.3859L14.537 13.2182Z"
      fill="currentColor"
    />
    <path
      d="M14.5847 13.1224L14.942 13.314C14.942 13.314 14.942 13.2901 14.9658 13.2901L14.6085 13.0984L14.5847 13.1224Z"
      fill="currentColor"
    />
    <path
      d="M14.6562 13.0266L14.9897 13.2661L15.0136 13.2422L14.6801 13.0026L14.6562 13.0266Z"
      fill="currentColor"
    />
    <path
      d="M14.7516 12.9068L14.7278 12.9308L15.0374 13.1943L15.0613 13.1703L14.7516 12.9068Z"
      fill="currentColor"
    />
    <path
      d="M14.8468 12.835L14.823 12.8589L15.1088 13.1464L15.1327 13.1224L14.8468 12.835Z"
      fill="currentColor"
    />
    <path
      d="M14.9181 12.7631L14.8943 12.7871L15.1325 13.0985L15.1563 13.0745L14.9181 12.7631Z"
      fill="currentColor"
    />
    <path
      d="M15.0372 12.6913L15.0134 12.7152L15.204 13.0505C15.204 13.0505 15.2278 13.0505 15.2278 13.0266L15.0372 12.6913Z"
      fill="currentColor"
    />
    <path
      d="M15.1327 12.6434L15.1089 12.6673L15.2756 13.0266C15.2756 13.0266 15.2994 13.0266 15.2994 13.0026L15.1327 12.6434Z"
      fill="currentColor"
    />
    <path
      d="M15.2516 12.5954H15.2278L15.3469 12.9547H15.3707L15.2516 12.5954Z"
      fill="currentColor"
    />
    <path
      d="M15.3707 12.5715H15.3469L15.4184 12.9547C15.4422 12.9547 15.4422 12.9547 15.4422 12.9547L15.3707 12.5715Z"
      fill="currentColor"
    />
    <path
      d="M15.5138 12.9547C15.5376 12.9547 15.5376 12.9547 15.5615 12.9547L15.5138 12.5475H15.49L15.5138 12.9547Z"
      fill="currentColor"
    />
    <path
      d="M15.6089 12.5475H15.5613V12.9547H15.5851L15.6089 12.5475Z"
      fill="currentColor"
    />
    <path
      d="M15.6567 12.9547C15.6806 12.9547 15.6806 12.9547 15.6806 12.9547L15.7282 12.5475H15.7044L15.6567 12.9547Z"
      fill="currentColor"
    />
    <path
      d="M15.752 12.9547L15.8473 12.5715H15.8235L15.752 12.9547Z"
      fill="currentColor"
    />
    <path
      d="M15.9664 12.6194H15.9426L15.8235 12.9787H15.8473L15.9664 12.6194Z"
      fill="currentColor"
    />
    <path
      d="M16.0617 12.6673L16.0378 12.6434L15.8711 13.0026C15.8711 13.0026 15.8949 13.0026 15.8949 13.0266L16.0617 12.6673Z"
      fill="currentColor"
    />
    <path
      d="M16.1329 12.6913L15.9424 13.0266L15.9662 13.0505L16.1568 12.7152L16.1329 12.6913Z"
      fill="currentColor"
    />
    <path
      d="M15.9902 13.0745L16.0141 13.0985L16.2523 12.7871L16.2284 12.7631L15.9902 13.0745Z"
      fill="currentColor"
    />
    <path
      d="M16.0615 13.1224L16.0853 13.1464L16.3474 12.8589L16.3235 12.835L16.0615 13.1224Z"
      fill="currentColor"
    />
    <path
      d="M16.3876 12.8882L16.0859 13.1598L16.1177 13.1955L16.4194 12.9239L16.3876 12.8882Z"
      fill="currentColor"
    />
    <path
      d="M16.1807 13.2422C16.1807 13.2661 16.1807 13.2661 16.2045 13.2661L16.5141 13.0266L16.4903 13.0026L16.1807 13.2422Z"
      fill="currentColor"
    />
    <path
      d="M16.2046 13.2901C16.2046 13.314 16.2046 13.314 16.2046 13.314L16.5381 13.1224L16.5143 13.0984L16.2046 13.2901Z"
      fill="currentColor"
    />
    <path
      d="M16.2522 13.3619C16.2522 13.3859 16.2522 13.3859 16.2522 13.3859L16.6095 13.2182L16.5857 13.1942L16.2522 13.3619Z"
      fill="currentColor"
    />
    <path
      d="M16.2759 13.4338V13.4577L16.6332 13.338L16.6094 13.314L16.2759 13.4338Z"
      fill="currentColor"
    />
    <path
      d="M16.2998 13.5056V13.5296L16.6809 13.4338V13.4098L16.2998 13.5056Z"
      fill="currentColor"
    />
    <path
      d="M16.2998 13.5775V13.6014L16.6809 13.5775V13.5535L16.2998 13.5775Z"
      fill="currentColor"
    />
    <path
      d="M16.3236 13.6733L16.7047 13.6972V13.6493H16.2998C16.3236 13.6493 16.3236 13.6733 16.3236 13.6733Z"
      fill="currentColor"
    />
    <path
      d="M16.2998 13.817C16.2998 13.841 16.2998 13.841 16.2998 13.841L16.6809 13.9368V13.9128L16.2998 13.817Z"
      fill="currentColor"
    />
    <path
      d="M16.7048 13.817V13.7931L16.3237 13.7451V13.7691L16.7048 13.817Z"
      fill="currentColor"
    />
    <path
      d="M16.6332 14.0326V14.0086L16.2759 13.8889V13.9128L16.6332 14.0326Z"
      fill="currentColor"
    />
    <path
      d="M16.2521 13.9607C16.2521 13.9607 16.2521 13.9847 16.2283 13.9847L16.5856 14.1523L16.6094 14.1284L16.2521 13.9607Z"
      fill="currentColor"
    />
    <path
      d="M16.2046 14.0565L16.5381 14.2481L16.5619 14.2242L16.2284 14.0326C16.2284 14.0326 16.2046 14.0326 16.2046 14.0565Z"
      fill="currentColor"
    />
    <path
      d="M16.157 14.1284L16.6572 14.4877L16.681 14.4637L16.2046 14.1044C16.1808 14.1044 16.1808 14.1044 16.157 14.1284Z"
      fill="currentColor"
    />
    <path
      d="M16.133 14.1523L16.1091 14.1763L17.0143 15.0146L17.0381 14.9907L16.133 14.1523Z"
      fill="currentColor"
    />
    <path
      d="M16.0615 14.2242L16.6808 14.9428L16.7047 14.9188L16.0853 14.2002C16.0853 14.2242 16.0853 14.2242 16.0615 14.2242Z"
      fill="currentColor"
    />
    <path
      d="M16.0139 14.2721L16.7047 15.2062L16.7285 15.1823L16.0377 14.2481C16.0139 14.2721 16.0139 14.2721 16.0139 14.2721Z"
      fill="currentColor"
    />
    <path
      d="M15.9424 14.32L16.4188 15.1583L16.4426 15.1344L15.9662 14.2961C15.9424 14.32 15.9424 14.32 15.9424 14.32Z"
      fill="currentColor"
    />
    <path
      d="M15.8711 14.344L16.3237 15.326L16.3475 15.302L15.8949 14.32C15.8949 14.344 15.8711 14.344 15.8711 14.344Z"
      fill="currentColor"
    />
    <path
      d="M15.7996 14.3679L15.9901 14.9428H16.0139L15.8234 14.3439C15.8234 14.3679 15.7996 14.3679 15.7996 14.3679Z"
      fill="currentColor"
    />
    <path
      d="M15.728 14.3919L15.9662 15.3979H15.99L15.7518 14.3919H15.728Z"
      fill="currentColor"
    />
    <path
      d="M12.2265 21.0266C12.2265 21.0266 12.1074 21.1463 12.1788 21.2661C12.2503 21.338 12.3694 21.3619 12.4409 21.29L12.4647 21.2661C12.4647 21.2661 12.2027 21.2661 12.2265 21.0266Z"
      fill="currentColor"
    />
    <path
      d="M18.7295 21.2661C18.801 21.338 18.9201 21.3619 18.9915 21.29L19.0153 21.2661C19.0868 21.1463 18.9677 21.0266 18.9677 21.0266C18.9915 21.2661 18.7295 21.2661 18.7295 21.2661Z"
      fill="currentColor"
    />
    <path
      d="M13.2509 20.8829L13.2032 20.8589L13.0603 21.0984L13.1079 21.1224C13.1794 21.1463 13.2747 21.1224 13.2985 21.0505C13.3223 21.0026 13.2985 20.9308 13.2509 20.8829Z"
      fill="currentColor"
    />
    <path
      d="M13.7271 21.1224C13.6557 21.0984 13.5842 21.1224 13.5366 21.1943C13.4889 21.2661 13.5366 21.338 13.5842 21.3859C13.6557 21.4338 13.7271 21.3859 13.7748 21.338C13.7748 21.338 13.7748 21.338 13.7748 21.314C13.8224 21.2661 13.7986 21.1703 13.7271 21.1224Z"
      fill="currentColor"
    />
    <path
      d="M15.3707 21.5535C15.2992 21.5535 15.2278 21.6014 15.2278 21.6972C15.2278 21.7691 15.2754 21.841 15.3469 21.841C15.4183 21.841 15.4898 21.7931 15.4898 21.7212V21.6972C15.5136 21.6254 15.466 21.5775 15.3707 21.5535Z"
      fill="currentColor"
    />
    <path
      d="M16.7046 21.5775L16.6333 21.6014L16.6571 21.7209L16.7284 21.697C16.7522 21.697 16.776 21.6492 16.776 21.6253C16.7997 21.6014 16.7522 21.5775 16.7046 21.5775C16.7284 21.5775 16.7284 21.5775 16.7046 21.5775Z"
      fill="currentColor"
    />
    <path
      d="M16.7283 21.4576C16.7283 21.4337 16.7046 21.4098 16.657 21.4098L16.5857 21.4337L16.6095 21.5533L16.6808 21.5294C16.7283 21.5294 16.7521 21.5055 16.7283 21.4576C16.7283 21.4815 16.7283 21.4815 16.7283 21.4576Z"
      fill="currentColor"
    />
    <path
      d="M17.2525 21.2422C17.2287 21.2422 17.2287 21.2422 17.2049 21.2422L17.1572 21.2661L17.2049 21.3859L17.2763 21.3619C17.3001 21.3619 17.324 21.314 17.324 21.2901C17.3001 21.2661 17.2763 21.2422 17.2525 21.2422Z"
      fill="currentColor"
    />
    <path
      d="M17.7528 21.0505L17.7766 21.1703L17.8719 21.1224L17.7766 21.0266C17.7528 21.0026 17.729 20.9787 17.729 20.9787C17.729 21.0026 17.7528 21.0505 17.7528 21.0505Z"
      fill="currentColor"
    />
    <path
      d="M18.8247 21.0984L18.7056 21.0505C18.777 21.0266 18.8723 21.0026 18.9676 21.0266L18.8247 20.8829C18.5388 20.6194 18.0863 20.5475 17.7528 20.7392C16.4427 21.5535 14.7991 21.5535 13.489 20.7392C13.1317 20.5475 12.7029 20.6194 12.4171 20.8829L12.2742 21.0266C12.3694 21.0026 12.4409 21.0266 12.5362 21.0505L12.4171 21.0984C12.56 21.1703 12.5124 21.2661 12.5124 21.2661L12.7029 21.0984C12.9888 21.2182 13.2508 21.3619 13.5128 21.5056C14.156 21.8649 14.8944 22.0565 15.6566 22.0565C16.395 22.0805 17.1335 21.8889 17.8004 21.5056C18.0624 21.3619 18.3245 21.2182 18.6103 21.0984L18.8009 21.2661C18.7294 21.2661 18.6579 21.1463 18.8247 21.0984ZM13.084 21.1703L12.9649 21.0984L13.1555 20.7631L13.2746 20.835C13.3699 20.8829 13.3937 21.0026 13.3461 21.0984C13.2984 21.1943 13.1793 21.2182 13.084 21.1703ZM13.3461 21.314L13.2984 21.2901L13.4652 20.9547L13.5128 20.9787L13.3461 21.314ZM13.5843 21.4338C13.489 21.3859 13.4413 21.2661 13.489 21.1703C13.5366 21.0745 13.6557 21.0266 13.751 21.0745C13.8463 21.1224 13.8939 21.2422 13.8463 21.338C13.7986 21.4338 13.6796 21.4817 13.5843 21.4338ZM14.1083 21.338C14.0845 21.314 14.0607 21.2901 14.0368 21.2661C14.013 21.2422 13.9654 21.2661 13.9654 21.2901C13.9416 21.3619 14.1083 21.4098 14.0607 21.5296C14.0369 21.5775 13.9654 21.6014 13.9177 21.6014C13.8701 21.5775 13.8463 21.5535 13.8225 21.5056L13.8701 21.4817C13.8939 21.5056 13.9178 21.5296 13.9416 21.5535C13.9654 21.5775 14.013 21.5535 14.013 21.5296C14.0369 21.4577 13.8701 21.4098 13.9177 21.2901C13.9416 21.2422 14.013 21.2182 14.0607 21.2422C14.1083 21.2661 14.1321 21.2901 14.1559 21.314L14.1083 21.338ZM14.418 21.7452C14.3465 21.7212 14.2989 21.6493 14.2989 21.5775C14.2989 21.5775 14.2989 21.5775 14.2989 21.5535L14.3703 21.314L14.418 21.338L14.3465 21.5775C14.3227 21.6254 14.3703 21.6733 14.418 21.6972C14.4656 21.7212 14.5133 21.6733 14.5371 21.6254L14.6085 21.3859L14.6562 21.4098L14.5847 21.6493C14.5847 21.7212 14.5133 21.7691 14.418 21.7452ZM14.942 21.8649H14.8944L14.7753 21.6014C14.7753 21.5775 14.7514 21.5296 14.7514 21.5296C14.7514 21.5296 14.7514 21.5535 14.7514 21.5775L14.7038 21.817H14.6562L14.7276 21.4338H14.7753L14.8944 21.6972C14.8944 21.7212 14.9182 21.7452 14.9182 21.7452C14.9182 21.7452 14.9182 21.7212 14.9182 21.6972L14.9658 21.4577H15.0135L14.942 21.8649ZM15.0849 21.8649H15.0373L15.0849 21.4817H15.1326L15.0849 21.8649ZM15.347 21.9128C15.2517 21.9128 15.1564 21.817 15.1564 21.7212C15.1564 21.6254 15.2517 21.5296 15.3708 21.5535C15.4661 21.5535 15.5613 21.6493 15.5375 21.7452C15.5613 21.817 15.4661 21.9128 15.347 21.9128C15.3708 21.9128 15.3708 21.9128 15.347 21.9128ZM15.871 21.8889L15.7043 21.6493C15.6804 21.6254 15.6804 21.6014 15.6804 21.6014C15.6804 21.6014 15.6804 21.6254 15.6804 21.6493V21.8889H15.6328L15.609 21.5056H15.6566L15.8234 21.7452C15.8472 21.7691 15.8472 21.7931 15.8472 21.7931C15.8472 21.7931 15.8472 21.7691 15.8472 21.7452V21.5056H15.8948L15.9186 21.8889H15.871ZM16.2283 21.8649L16.1568 21.4817H16.2045L16.2521 21.817L16.4189 21.7931V21.841L16.2283 21.8649ZM16.4903 21.817L16.4189 21.4338H16.4665L16.538 21.817H16.4903ZM16.7523 21.7452L16.6332 21.7691L16.538 21.4098L16.6571 21.3859C16.7047 21.3619 16.7523 21.3859 16.7762 21.4338C16.7762 21.4577 16.7762 21.5056 16.7523 21.5296C16.8 21.5296 16.8238 21.5535 16.8238 21.6014C16.8714 21.6733 16.8238 21.7212 16.7523 21.7452ZM16.9429 21.6972L16.8238 21.338L17.0382 21.2661L17.062 21.314L16.8953 21.3619L16.9429 21.4817L17.062 21.4338L17.0858 21.4817L16.9667 21.5296L17.0144 21.6493L17.1811 21.6014L17.2049 21.6493L16.9429 21.6972ZM17.4193 21.5296L17.3002 21.4098L17.2287 21.4338L17.2764 21.5775L17.2287 21.6014L17.0858 21.2422L17.1811 21.1943C17.2049 21.1943 17.2287 21.1703 17.2526 21.1703C17.324 21.1703 17.3717 21.2182 17.3478 21.2901C17.3478 21.314 17.324 21.338 17.324 21.3619C17.324 21.3619 17.324 21.3619 17.3478 21.3859L17.4669 21.4817L17.4193 21.5296ZM17.6099 21.4338L17.4669 21.1224L17.3478 21.1703L17.324 21.1224L17.6099 20.9787L17.6337 21.0266L17.5146 21.0745L17.6575 21.3859L17.6099 21.4338ZM17.991 21.2422L17.8957 21.1703L17.7766 21.2422L17.8004 21.3619L17.7528 21.3859L17.6813 20.9787L17.729 20.9547L18.0386 21.2182L17.991 21.2422ZM18.1815 21.1224L18.0863 21.1943L17.8957 20.8829L17.991 20.811C18.0863 20.7631 18.2054 20.7871 18.253 20.8829C18.3006 20.9547 18.2768 21.0745 18.1815 21.1224Z"
      fill="currentColor"
    />
    <path
      d="M17.991 20.8589L17.9434 20.9068L18.0863 21.1463L18.1339 21.0984C18.2054 21.0505 18.2054 20.9547 18.1577 20.9068C18.1339 20.835 18.0625 20.811 17.991 20.8589Z"
      fill="currentColor"
    />
  </>
);
